// src/utils/contarEvidencias.js
//
// Cuenta evidencias por tipo a partir del array que devuelve
// api.fetchEvidenciasInforme(id_item_evaluacion).
// No hace fetch. Función pura.
//
// Discriminación de tipo por extensión de referencia_archivo:
//   foto  -> .jpg .jpeg .png
//   video -> .mp4 .mov .webm  (aún no se generan; contemplado a futuro)
// Filtro defensivo por baja == null (el endpoint ya filtra server-side).

const EXT_FOTO = ['jpg', 'jpeg', 'png'];
const EXT_VIDEO = ['mp4', 'mov', 'webm'];

function extensionDe(referencia) {
  if (typeof referencia !== 'string') return '';
  const limpia = referencia.split('?')[0].split('#')[0];
  const punto = limpia.lastIndexOf('.');
  if (punto === -1) return '';
  return limpia.slice(punto + 1).toLowerCase();
}

export function contarEvidencias(evidencias) {
  const lista = Array.isArray(evidencias) ? evidencias : [];
  let fotos = 0;
  let videos = 0;
  for (const ev of lista) {
    if (ev && ev.baja != null) continue; // red de seguridad; endpoint ya filtra
    const ext = extensionDe(ev && ev.referencia_archivo);
    if (EXT_FOTO.includes(ext)) fotos += 1;
    else if (EXT_VIDEO.includes(ext)) videos += 1;
  }
  return { fotos, videos, total: fotos + videos };
}
